export const FETCH_RECORDING_CALLS_SUCCESS = 'FETCH_RECORDING_CALLS_SUCCESS';
export const RECORDINGS_CALLS_ADD = 'RECORDINGS_CALLS_ADD';
export const RECORDINGS_CALLS_RESET = 'RECORDINGS_CALLS_RESET';
